import "./ActivityRing.scss";

interface Props {
  data: statsProps[];
  ringWidth: number;
  hasVerticalStats?: boolean;
  hasLabel?: boolean;
  innerLabel?: string;
}
interface statsProps {
  label?: string;
  value: number;
  color?: string;
  textColor?: string;
}

const ActivityRing = ({
  data,
  ringWidth,
  hasLabel,
  hasVerticalStats,
  innerLabel,
}: Props) => {
  
  return (
    <div className={`${hasVerticalStats ? "d-flex " : ""}`}>
      {/* <p>{JSON.stringify(data)}</p> */}
      <svg
        className="activity-rings"
        viewBox="0 0 25 25"
        style={{ minWidth: "90%" }}
      >
        <text x="30%" y="60%" fontSize="2" className="font-weight-bold">
          {innerLabel}
        </text>
        {data.map((ele, index: number) => (
          <g
            className={`ring tran${index + 1}`}
            style={{ transformOrigin: "50%" }}
            key={index}
          >
            <circle
              className="background "
              cx="50%"
              cy="50%"
              r={`${14.915 + index}`}
              strokeWidth={ringWidth}
              stroke="#E9EFF2"
              fill="none"
            />
            <circle
              className="completed"
              cx="50%"
              cy="50%"
              r={`${14.915 + index}`}
              strokeWidth={ringWidth}
              stroke={ele.color}
              // strokeDasharray={`${
              //   index === 0 ? (ele.value === 0 ? 0 : ele.value - 6) : ele.value
              // } 100`}
              strokeDasharray={`${
                index === 0
                  ? ele.value < 6
                    ? ele?.value
                    : ele.value - 6
                  : ele.value
              } 100`}
              fill="none"
            />
          </g>
        ))}
      </svg>

      {hasLabel && (
        <div className="d-flex flex-wrap justify-content-center">
          {data.map((e, index) => (
            <div className="mx-2 mt-2 text-center" key={index}>
              <p className="font-weight-bold pb-0 mb-0">{e.label}</p>
              <p
                className="font-weight-bold pt-0 mt-0"
                style={{ color: e.color }}>
                {e.value}%
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ActivityRing;
